import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Grid, MenuItem, Typography, Checkbox, FormControlLabel } from '@mui/material';
import { listarInstituicoes } from '../../services/instituicaoService';

const tiposInstituicao = ['Universidade', 'Colégio', 'Instituto Técnico'];

const FormCampanha = ({ onSubmit, campanhaInicial = {} }) => {
  const [campanha, setCampanha] = useState(campanhaInicial);
  const [instituicoes, setInstituicoes] = useState([]);
  const [usarMensagemPersonalizada, setUsarMensagemPersonalizada] = useState(false);

  useEffect(() => {
    const fetchInstituicoes = async () => {
      try {
        const data = await listarInstituicoes();
        setInstituicoes(data);
      } catch (error) {
        console.error('Erro ao buscar instituições:', error);
      }
    };
    fetchInstituicoes();
  }, []);

  useEffect(() => {
    setCampanha(campanhaInicial);
    setUsarMensagemPersonalizada(!!campanhaInicial.mensagemConfirmacaoPersonalizada);
  }, [campanhaInicial]);

  const handleChange = (e) => {
    setCampanha({ ...campanha, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const campanhaParaEnviar = { ...campanha };
    if (!usarMensagemPersonalizada) {
      delete campanhaParaEnviar.mensagemConfirmacaoPersonalizada;
    }
    onSubmit(campanhaParaEnviar);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Criar Nova Campanha</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nome da Campanha"
            name="nome"
            value={campanha.nome || ''}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            select
            label="Tipo de Instituição"
            name="tipoInstituicao"
            value={campanha.tipoInstituicao || ''}
            onChange={handleChange}
            required
          >
            {tiposInstituicao.map((tipo) => (
              <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            select
            label="Instituição"
            name="instituicaoId"
            value={campanha.instituicaoId || ''}
            onChange={handleChange}
            required
          >
            {instituicoes.map((instituicao) => (
              <MenuItem key={instituicao.id} value={instituicao.id}>{instituicao.nome}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Data de Início"
            name="dataInicio"
            type="date"
            value={campanha.dataInicio || ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Data de Fim"
            name="dataFim"
            type="date"
            value={campanha.dataFim || ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            select
            label="Status"
            name="status"
            value={campanha.status || 'Ativa'}
            onChange={handleChange}
            required
          >
            <MenuItem value="Ativa">Ativa</MenuItem>
            <MenuItem value="Inativa">Inativa</MenuItem>
            <MenuItem value="Concluída">Concluída</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Descrição"
            name="descricao"
            value={campanha.descricao || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={usarMensagemPersonalizada}
                onChange={(e) => setUsarMensagemPersonalizada(e.target.checked)}
                name="usarMensagemPersonalizada"
              />
            }
            label="Usar mensagem de confirmação personalizada"
          />
        </Grid>
        {usarMensagemPersonalizada && (
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Mensagem de Confirmação Personalizada"
              name="mensagemConfirmacaoPersonalizada"
              value={campanha.mensagemConfirmacaoPersonalizada || ''}
              onChange={handleChange}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary">
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

FormCampanha.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  campanhaInicial: PropTypes.shape({
    nome: PropTypes.string,
    tipoInstituicao: PropTypes.string,
    instituicaoId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    dataInicio: PropTypes.string,
    dataFim: PropTypes.string,
    status: PropTypes.string,
    descricao: PropTypes.string,
    mensagemConfirmacaoPersonalizada: PropTypes.string
  })
};

FormCampanha.defaultProps = {
  campanhaInicial: {}
};

export default FormCampanha;